import { useEffect, useRef, useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

// Lote 106 (Robson, 24/10/2026): dupla confirmação para dar baixa num prazo — evita baixa acidental.
// `confirmBaixa("nome do prazo")` abre a janela e devolve uma Promise<boolean>; o <ConfirmBaixaHost />
// fica montado uma vez no Layout. Reabrir o prazo (desfazer a baixa) NÃO pede confirmação.
let opener = null;
export function confirmBaixa(label = "", kind = "prazo") {
  if (!opener) return Promise.resolve(window.confirm(kind === "prazo" ? "Dar baixa neste prazo?" : "Marcar como realizada?"));
  return opener(label, kind);
}

export function ConfirmBaixaHost() {
  const [state, setState] = useState({ open: false, label: "", kind: "prazo" });
  const resolver = useRef(null);
  useEffect(() => {
    opener = (label, kind) => new Promise((resolve) => {
      if (resolver.current) resolver.current(false);
      resolver.current = resolve;
      setState({ open: true, label: label || "", kind: kind || "prazo" });
    });
    return () => { opener = null; };
  }, []);
  const close = (value) => {
    setState((s) => ({ ...s, open: false }));
    if (resolver.current) { resolver.current(value); resolver.current = null; }
  };
  return (
    <Dialog open={state.open} onOpenChange={(o) => { if (!o) close(false); }}>
      <DialogContent className="max-w-sm" data-testid="confirm-baixa">
        <DialogHeader>
          <DialogTitle>{state.kind === "prazo" ? "Dar baixa neste prazo?" : "Marcar como realizada?"}</DialogTitle>
          <DialogDescription>
            {state.label ? <span className="block font-medium text-stone-800 break-words mb-1">{state.label}</span> : null}
            {state.kind === "prazo" ? "O prazo sai das listas e dos alertas." : "O compromisso sai de “hoje” e vai para o histórico."} Você poderá desfazer em seguida.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:gap-2">
          <Button variant="outline" autoFocus data-testid="confirm-baixa-cancelar" onClick={() => close(false)}>Cancelar</Button>
          <Button data-testid="confirm-baixa-sim" onClick={() => close(true)} className="bg-emerald-brand text-white">{state.kind === "prazo" ? "Sim, prazo feito" : "Sim, realizada"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
